<template>
  <div>
    <sj-button style="margin:10px" @click="click1">Alert</sj-button>
    <sj-button style="margin:10px" @click="click2">Confirm</sj-button>
    <sj-button style="margin:10px" @click="click3">Prompt</sj-button>
    <sj-button style="margin:10px" @click="click4">Prompt Validator</sj-button>
  </div>
</template>

<script>
export default {
  methods: {
    sleep(time) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    click1() {
      this.$SjAlert({
        message:
          "该账号无法企业用户登录，请切换微信扫码登录，这里的行数是可以变多的，即高度是可变的",
        title: "title",
        width: "360px",
        confirmText: "confirm"
      });
    },
    click2() {
      this.$SjConfirm("Confirm", "Title", {})
        .then(() => {
          this.$SjAlert({
            message: `确认`,
            showHeader: false
          });
        })
        .catch(() => {
          this.$SjAlert({
            message: `取消`,
            showHeader: false
          });
        });
    },
    click3() {
      this.$SjPrompt("Prompt", "Title")
        .then(value => {
          this.$SjAlert({
            message: `确认 ${value}`,
            showHeader: false
          });
        })
        .catch(() => {
          this.$SjAlert({
            message: `取消`,
            showHeader: false
          });
        });
    },
    click4() {
      this.$SjPrompt("Prompt w/ validation", "Title", {
        placeholder: "不能为空",
        validator(value) {
          return !!value;
        },
        onCloseConfirmText: "等待1秒",
        onClose: async () => {
          await this.sleep(1000);
        }
      })
        .then(value => {
          this.$SjAlert({
            message: `确认 ${value}`,
            showHeader: false
          });
        })
        .catch(() => {
          this.$SjAlert({
            message: `取消`,
            showHeader: false
          });
        });
    }
  }
};
</script>

<style scoped lang="less"></style>
